import Button from 'components/Button';
import Loading from 'components/Loading';
import Select from 'components/Select';
import Textarea from 'components/Textarea';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Modal from 'react-modal';

import './style.scss';

export default class Feedback extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    subjects: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    saveSuccess: PropTypes.bool.isRequired,
  };

  state = {
    text: '',
    selectedSubjectsId: '',
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen && !this.hasAllData()) {
      this.sendGetSubjectsRequest();
    }
  }

  getFeedback() {
    return {
      text: this.state.text,
      subject: +this.state.selectedSubjectsId.value,
    };
  }

  clear() {
    this.setState({
      text: '',
      selectedSubjectsId: '',
    });
  }

  hasAllData() {
    const { subjects } = this.props;
    return get(subjects, 'length', 0) > 0;
  }

  saveSubject(selectedSubjectsId) {
    this.setState({
      selectedSubjectsId,
    });
  }

  sendFeedback() {}

  closeModal() {}

  sendGetSubjectsRequest() {}

  renderFeedback() {
    const { text, selectedSubjectsId } = this.state;
    const { subjects, saveSuccess } = this.props;

    const successMessage = (
      <div className="feedback__content">
        <p>Ваш отзыв отправлен</p>
        <div className="feedback_buttons">
          <Button onClick={() => this.closeModal(true)}>Закрыть</Button>
        </div>
      </div>
    );

    const modalBody = (
      <div className="feedback__content">
        <p>
          Если у вас есть предложения или замечания, связанные с работой Личного кабинета,
          пожалуйста, напишите нам.
        </p>
        <Select
          options={subjects}
          value={selectedSubjectsId}
          onChange={(id) => this.saveSubject(id)}
          isFull={true}
          placeholder="Тема"
        />
        <Textarea
          value={text}
          onChange={(e) => this.setState({ text: e.target.value })}
          placeholder="Сообщение"
        />
        <div className="feedback_buttons">
          <Button
            type="Button"
            size="medium"
            color="orange"
            onClick={() => this.sendFeedback()}
            isDisabled={this.state.text.length === 0 || this.state.selectedSubjectsId === ''}
          >
            Отправить
          </Button>
          <Button type="Button" size="medium" onClick={() => this.closeModal()}>
            Отменить
          </Button>
        </div>
      </div>
    );

    return saveSuccess ? successMessage : modalBody;
  }

  renderLoading() {
    return (
      <div className="feedback_loading">
        <Loading />
      </div>
    );
  }

  render() {
    const { isOpen, loading, saveSuccess } = this.props;

    return (
      <Modal
        ref={(modal) => (this.modal = modal)}
        isOpen={isOpen}
        contentLabel="dummy"
        style={{
          overlay: {
            zIndex: 5000,
            backgroundColor: 'rgba(74,74,74,0.3)',
          },
          content: {
            border: 'none',
            backgroundColor: 'rgba(0,0,0,0)',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
          },
        }}
      >
        <div className="mfp-container mfp-inline-holder">
          <div className="mfp-content">
            <div className="popup popup__750" id="info">
              <a
                className="mfp-close popup_close"
                onClick={() => this.closeModal(saveSuccess || false)}
              />
              <div className="popup_wrapper popup_wrapper__white info">
                <h2>Отзыв о Личном кабинете Налогоплательщика</h2>
                {loading ? this.renderLoading() : this.renderFeedback()}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
